import {FC} from 'react'

import {getPricingContent} from '@/content/pricing'
import {useTranslation} from '@/i18n'
import {Jurisdiction} from '@/utils/countries/constants'
import {useRouter} from '@/utils/hooks/useRouter'
import {useLanguage} from '@/utils/i18n/language'
import {calculateOfferingPrice, formatCategoryFees, getCategoryFees} from '@/utils/pricing'
import {routeTo} from '@/utils/router'

import {PricingCalculatorTable} from '../calculator/PricingCalculatorTable'
import {PricingTrademarkRegistrationEstimationCard} from './PricingTrademarkRegistrationEstimationCard'

export const PricingTrademarkRegistrationTable: FC = () => {
  const {subtitle, calculator} = getPricingContent().registration
  const {t} = useTranslation('page')
  const language = useLanguage()

  const router = useRouter()
  const countryQuery = router.query?.countrySpecific?.toString().toLowerCase()

  const getLinkHref = (selectedJurisdictions: Jurisdiction[]) =>
    routeTo.verification.form({
      country: selectedJurisdictions.join(',').toLowerCase() || undefined,
      countrySpecific: countryQuery,
    })

  return (
    <PricingCalculatorTable
      subtitle={subtitle}
      startButtonText={calculator.startButtonText}
      continueButtonText={calculator.continueButtonText}
      getLinkHref={getLinkHref}
      trackedEventName="VerificationButtonPricelist"
      EstimationCard={PricingTrademarkRegistrationEstimationCard}
      showDiscountBanner
      allowEuMemberSelection={false}
      getJurisdictionPricing={(jurisdiction, currency) => ({
        price: calculateOfferingPrice([jurisdiction], currency).total,
        renderTooltip: (tooltipTextKey) =>
          t(
            tooltipTextKey,
            formatCategoryFees(getCategoryFees(jurisdiction, currency), currency, language),
          ),
      })}
    />
  )
}
